var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
    },
    [
      _c("el-image", {
        staticClass: "banner",
        attrs: { src: _vm.HomeBanner, fit: "cover" },
      }),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "switch-tab" }, [
          _c("div", {
            staticClass: "tab-bar",
            class: { right: _vm.activeIndex === 1 },
          }),
          _c(
            "div",
            {
              staticClass: "tab-item",
              attrs: { "data-active": _vm.activeIndex === 0 },
              on: {
                click: function ($event) {
                  _vm.activeIndex = 0
                },
              },
            },
            [_vm._v("学校")]
          ),
          _c(
            "div",
            {
              staticClass: "tab-item",
              attrs: { "data-active": _vm.activeIndex === 1 },
              on: {
                click: function ($event) {
                  _vm.activeIndex = 1
                },
              },
            },
            [_vm._v("日期")]
          ),
        ]),
        _vm.activeIndex === 0
          ? _c(
              "div",
              { staticClass: "school-container" },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入学校名称",
                    type: "search",
                    "suffix-icon": "el-icon-search",
                  },
                  on: { change: _vm.getSchoolList },
                  model: {
                    value: _vm.keywords,
                    callback: function ($$v) {
                      _vm.keywords = $$v
                    },
                    expression: "keywords",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "school-list" },
                  _vm._l(_vm.schoolList, function (item) {
                    return _c("SchoolBox", {
                      key: item.id,
                      attrs: { "school-data": item },
                    })
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.activeIndex === 1
          ? _c("div", { staticClass: "live-container" }, [
              _c("div", { staticClass: "filter-area" }, [
                _c("div", { staticClass: "filters" }, [
                  _c(
                    "div",
                    {
                      staticClass: "custom-select",
                      on: { click: _vm.selectStatus },
                    },
                    [
                      _vm.searchConditions.status === 0
                        ? _c("span", [_vm._v("直播状态")])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.statusList.find(
                                  (item) =>
                                    item.id === _vm.searchConditions.status
                                ).name
                              )
                            ),
                          ]),
                      _c("i", { staticClass: "el-icon-caret-bottom" }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "custom-select",
                      on: {
                        click: function ($event) {
                          _vm.showCalender = true
                        },
                      },
                    },
                    [
                      !_vm.searchConditions.date
                        ? _c("span", [_vm._v("直播时间")])
                        : _c("span", [
                            _vm._v(_vm._s(_vm.searchConditions.date)),
                          ]),
                      _c("i", { staticClass: "el-icon-caret-bottom" }),
                    ]
                  ),
                  _vm.searchConditions.status || _vm.searchConditions.date
                    ? _c(
                        "div",
                        {
                          staticClass: "clear-btn",
                          on: { click: _vm.clearFilter },
                        },
                        [
                          _c("i", { staticClass: "el-icon-close" }),
                          _c("span", [_vm._v("清空筛选")]),
                        ]
                      )
                    : _vm._e(),
                ]),
                _c("span", { staticClass: "live-count" }, [
                  _vm._v("共" + _vm._s(_vm.liveList.length) + "场直播"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "live-list" },
                _vm._l(_vm.liveList, function (item) {
                  return _c("ListCard", {
                    key: item.id,
                    attrs: { "card-data": item },
                  })
                }),
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm.showCalender
        ? _c("calendar", {
            ref: "vCalendar",
            attrs: {
              show: _vm.showCalender,
              mode: "single",
              "default-date": _vm.searchConditions.date,
              "day-click": _vm.checkSelectDate,
            },
            on: {
              "update:show": function ($event) {
                _vm.showCalender = $event
              },
              change: _vm.onDateChange,
            },
          })
        : _vm._e(),
      _vm.showSelect
        ? _c("CustomSelect", {
            attrs: {
              options: _vm.statusList,
              value: _vm.searchConditions.status,
            },
            on: {
              confirm: _vm.handleConfirm,
              cancel: function ($event) {
                _vm.showSelect = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }